module.exports = __webpack_public_path__ + "img/2.44045ee.svg";